import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=77f8ac34&scoped=true&"
import script from "./ProductForm.vue?vue&type=script&lang=js&"
export * from "./ProductForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=77f8ac34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f8ac34",
  null
  
)

export default component.exports